/**
 * Sidebar Icon
 *
 */

import type { SVGProps } from 'react'

export default function usage(props: SVGProps<SVGSVGElement> = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.81701 4.524L10.917 0.955998C11.6114 0.680998 12.3846 0.680998 13.079 0.955998L22.179 4.524C22.5032 4.66224 22.7785 4.89448 22.9694 5.19073C23.1603 5.48698 23.2581 5.83365 23.25 6.186V17.814C23.2584 18.1659 23.1612 18.5122 22.9711 18.8084C22.7809 19.1046 22.5065 19.3371 22.183 19.476L13.083 23.045C12.3882 23.318 11.6158 23.318 10.921 23.045L1.82101 19.476C1.49682 19.3378 1.2215 19.1055 1.0306 18.8093C0.839691 18.513 0.741958 18.1663 0.750012 17.814V6.186C0.741629 5.83411 0.838773 5.48776 1.02893 5.19156C1.2191 4.89536 1.49357 4.66286 1.81701 4.524V4.524Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.353L1.104 5.081"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.353L22.896 5.081"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 23.25V9.353"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
